import fonts from './fonts'


const textStyles = {
  titleH1: {
    ...fonts.HILVCCBoingBold,
    fontSize: '4.6rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  titleH1Mobile: {
    ...fonts.HILVCCBoingBold,
    fontSize: '2.8rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  titleH2: {
    ...fonts.HILVCCBoingBold,
    fontSize: '3.4rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  titleH2Mobile: {
    ...fonts.HILVCCBoingBold,
    fontSize: '2.2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  titleH3: {
    ...fonts.HILVCCBoingBold,
    fontSize: '2.6rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  titleH3Mobile: {
    ...fonts.HILVCCBoingBold,
    fontSize: '2.3rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  textRegular: {
    ...fonts.HILVCCBoingRegular,
    fontSize: '1.8rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  textRegularMobile: {
    ...fonts.HILVCCBoingRegular,
    fontSize: '1.4rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  gameTitle: {
    ...fonts.HILVCCBoingBold,
    fontSize: '3.8rem',
    lineHeight: '4rem',
    letterSpacing: '-0.5px',
  },
  gameTitleMobile: {
    ...fonts.HILVCCBoingBold,
    fontSize: '2.7rem',
    lineHeight: '3rem',
    letterSpacing: '-0.5px',
  },
  downloadGame: {
    ...fonts.HILVCCBoingBold,
    fontSize: '2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  downloadGameMobile: {
    ...fonts.HILVCCBoingBold,
    fontSize: '1.6rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  fileSize: {
    ...fonts.HILVCCBoingLight,
    fontSize: '1.6rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  fileSizeMobile: {
    ...fonts.HILVCCBoingLight,
    fontSize: '1.4rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  stickKey: {
    ...fonts.HILVCCBoingRegular,
    fontSize: '2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  keyboardKey: {
    ...fonts.HILVCCBoingRegular,
    fontSize: '2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  tutorialText: {
    ...fonts.HILVCCBoingRegular,
    fontSize: '1.2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  carouselCurrentLookText: {
    ...fonts.UniversBoldCondensed,
    fontSize: '1.6rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  carouselCurrentLookTextMobile: {
    ...fonts.UniversBoldCondensed,
    fontSize: '1.2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  queueNumber: {
    ...fonts.UniversRoman,
    fontSize: '4rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
  queueNumberMobile: {
    ...fonts.UniversRoman,
    fontSize: '2rem',
    lineHeight: '1.2',
    letterSpacing: '-0.5px',
  },
}

export default textStyles
